function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export async function apiPost<T = any>(path: string, body: unknown): Promise<T> {
  const csrf = getCookie("aag_csrf") || "";
  const res = await fetch(path, {
    method: "POST",
    headers: { "Content-Type": "application/json", "X-CSRF-Token": csrf },
    body: JSON.stringify(body),
    credentials: "same-origin",
  });
  const data = await res.json();
  if (!res.ok && !data?.ok) {
    // laat de aanroeper de ApiError-vorm afhandelen
  }
  return data as T;
}

export async function apiGet<T = any>(path: string): Promise<T> {
  const res = await fetch(path, { credentials: "same-origin" });
  return (await res.json()) as T;
}
